export interface ExperienceItem {
  title: string;
  company: string;
  location: string;
  period: string;
  description: string;
  achievements: string[];
  technologies: string[];
}

export const EXPERIENCES: ExperienceItem[] = [
  {
    title: "Senior Software Developer",
    company: "Proprio Cloud Solutions",
    location: "Calgary, Canada (Remote)",
    period: "Jun 2024 - Present",
    description:
      "Develop and maintain embedded React applications for NetSuite. Collaborate with backend team to integrate frontend components with server-side logic.",
    achievements: [
      "Designed and led development of new mini application integrated with existing software",
      "Maintained software applications using React and Node.js (TypeScript)",
      "Mentored junior developers and QA automation engineers",
      "Conducted code reviews to uphold software development best practices",
      "Automated unit tests to identify regressions from future code changes",
    ],
    technologies: [
      "React",
      "TypeScript",
      "Node.js",
      "Redux",
      "NetSuite",
      "Git",
    ],
  },
  {
    title: "Architecture (Volunteer)",
    company: "Alberta Kids Sport",
    location: "Calgary, Canada",
    period: "Jan 2023 - Mar 2024",
    description:
      "Volunteered as technical architect, designing application infrastructure and leading development efforts.",
    achievements: [
      "Designed application infrastructure to support robust system performance",
      "Backend development using NestJS, Node.js, and TypeScript",
      "Led frontend development",
      "Planned sprints to ensure timely project milestones",
      "Direct communication with clients",
    ],
    technologies: ["NestJS", "Node.js", "TypeScript", "React"],
  },
  {
    title: "Senior Software Developer",
    company: "HIVERY",
    location: "Vancouver, BC (Remote)",
    period: "Aug 2023 - Jun 2024",
    description:
      "Developed features and performance improvements for the Curate product. Worked on cross-functional, remotely distributed team.",
    achievements: [
      "Developed and maintained software applications (React and NestJS)",
      "Optimized codebase by refactoring legacy components",
      "Integrated third-party APIs and micro-frontend architecture",
      "Monitored system performance metrics using DataDog",
      "Setting up Selenium UI tests",
    ],
    technologies: [
      "React",
      "NestJS",
      "TypeScript",
      "Module Federation",
      "Vitest",
      "DataDog",
    ],
  },
  {
    title: "Senior Software Developer",
    company: "EPAM Systems",
    location: "Calgary, Canada",
    period: "Mar 2022 - Aug 2023",
    description:
      "Lead developer and mentor, guiding middle and junior developers. Frontend development with Vue.js and TypeScript, backend with Perl.",
    achievements: [
      "Lead developer and mentor for junior/middle developers",
      "Frontend development using Vue.js and TypeScript",
      "Backend development with Perl",
      "Undergoing promotion process to Team Lead role",
      "Showcased leadership and mentoring skills",
    ],
    technologies: [
      "Vue.js",
      "TypeScript",
      "Perl",
      "SCSS",
      "Monorepo (Lerna)",
      "Vitest",
    ],
  },
  {
    title: "Lead Developer / Senior (Staff) Developer",
    company: "C.T.Co",
    location: "Riga, Latvia",
    period: "Mar 2020 - Jan 2022",
    description:
      "Started as lead developer, promoted to Senior (Staff) Developer. Developed applications using React, TypeScript, and Node.js.",
    achievements: [
      "Promoted from Lead Developer to Senior (Staff) Developer",
      "Built private Dropbox-like system and data collection apps",
      "Set up infrastructure using Azure and Ali Cloud",
      "Led small teams with successful project outcomes",
      "Delivered statistical data calculation and presentation app",
    ],
    technologies: [
      "React",
      "TypeScript",
      "Node.js",
      "Redux",
      "Azure",
      "StoryBook",
      "Jest",
    ],
  },
  {
    title: "Department Lead",
    company: "Dynatech",
    location: "Riga, Latvia",
    period: "Aug 2017 - Mar 2020",
    description:
      "Progressed from frontend developer to lead developer to department lead managing 100 developers across multiple teams.",
    achievements: [
      "Advanced to Department Lead managing 100 developers",
      "Led rebuilding of main flight ticket booking project",
      "Skyluxtravel.com nominated best travel project in 2019",
      "Responsible for technology selection for new projects",
      "Fostered collaborative environment and innovation",
    ],
    technologies: [
      "React",
      "Vue.js",
      "Next.js",
      "Nuxt.js",
      "Node.js",
      "GraphQL",
    ],
  },
  {
    title: "Programming Instructor",
    company: "Level-UP",
    location: "Dnipro, Ukraine",
    period: "Jan 2015 - Jan 2017",
    description:
      "Taught groups of 10-20 students the fundamentals of JavaScript, HTML, and CSS.",
    achievements: [
      "Created engaging lesson plans and interactive lectures",
      "Facilitated hands-on exercises to enhance learning",
      "Empowered individuals with web development skills",
    ],
    technologies: ["JavaScript", "HTML", "CSS"],
  },
];
